/*!
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

@use '../../../variables';
@use '../../../mixins';

.wireframe-container-injuries {
  @include mixins.page-grid-basics;
  grid-template-columns: auto 0.5fr;
  grid-template-rows: auto auto;
  grid-template-areas:
    'injury-location injury-activity'
    'injury-location injury-cause'
    'injury-accident-mechanism injury-accident-mechanism';
}
.injury-location {
  grid-area: injury-location;
}

.injury-activity {
  grid-area: injury-activity;
}

.injury-cause {
  grid-area: injury-cause;
}

.injury-accident-mechanism {
  grid-area: injury-accident-mechanism;
}
